// Kippt den Vektor um 90 Grad nach rechts
// Bei den Kippregeln muss man beachten, dass bei dem Koordinatensystem die y-Achse nach unten zeigt (Linksyystem).
// In einem Rechtssystem gibt es andere Kippregeln
export function Vector_90Right(v) {
    return {
        x: -v.y,
        y: v.x,
    };
}
// Kippt den Vektor um 90 Grad nach links
export function Vector_90Left(v) {
    return {
        x: v.y,
        y: -v.x,
    };
}
export function Vector_normalize(v) {
    // if (v.x === 0 && v.y === 0) return {x: 0, y: 0};
    const length = Math.sqrt(v.x ** 2 + v.y ** 2);
    return {
        x: v.x / length,
        y: v.y / length,
    };
}
// v1 und v2 sind Ortsvektoren, die zwei Punkte beschreiben
// Die Funktione gibt den Ortsvektor zurück, der den Mittelpunkt der beiden Punkte beschreibt
export function Vector_center(v1, v2) {
    return {
        x: (v1.x + v2.x) / 2,
        y: (v1.y + v2.y) / 2,
    };
}
export function Vector_add(v1, v2) {
    return {
        x: v1.x + v2.x,
        y: v1.y + v2.y,
    };
}
export function Vector_sub(v1, v2) {
    return {
        x: v1.x - v2.x,
        y: v1.y - v2.y,
    };
}
export function Vector_dotProduct(v1, v2) {
    return v1.x * v2.x + v1.y * v2.y;
}
export function line_intersectWithVerticalLine(p1a, p2a, x) {
    if (p1a.x === p2a.x) {
        // Die Gerade verläuft vertikal (d.h. in y-Richtung)
        // Es gibt keinen Schnittpunkt mit einer vertikalen Linie (oder die Linien liegen aufeinander)
        return undefined;
    }
    const t = (x - p1a.x) / (p2a.x - p1a.x);
    return {
        x: x,
        y: p1a.y + t * (p2a.y - p1a.y),
    };
}
export function line_intersectWithHorizontalLine(p1a, p2a, y) {
    if (p1a.y === p2a.y) {
        // Die Gerade verläuft horizontal (d.h. in x-Richtung)
        // Es gibt keinen Schnittpunkt mit einer horizontalen Linie (oder die Linien liegen aufeinander)
        return undefined;
    }
    const t = (y - p1a.y) / (p2a.y - p1a.y);
    return {
        x: p1a.x + t * (p2a.x - p1a.x),
        y: y,
    };
}
